/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archiveconfirmbtn2Inputs */



/**
* | output |
* | --- |
* | "Move" |
*
* @param {Archiveconfirmbtn2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const archiveconfirmbtn2 = /** @type {((inputs?: Archiveconfirmbtn2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archiveconfirmbtn2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Move")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover")
	return /** @type {LocalizedString} */ ("Отправить")
});
export { archiveconfirmbtn2 as "archiveConfirmBtn" }